export const environment = {
  production: false,
  apiUrl: "/v1",
  frontendKey: "0d1eeaa00cde7a7b0b5169299300de73",
  // Dev-only: the carrier polling-metrics tab + endpoint only exist on the dev
  // backend stack. The dev frontend builds with the `development` config (this
  // file); all prod brands build with `production` (environment.prod.ts).
  pollingMetrics: true,
};